<template>
  <div id="app">
    <top></top>
    <div class="container">
        <router-view />
        <bottom></bottom>
    </div>
  </div>
</template>

<script>
import bottom from "./components/common/bottom.vue";
import top from "./components/common/top.vue";
export default {
  name: "App",
  components: {
    top,
    bottom
  },
  data() {
    return {
      pathname: this.$route.fullPath,
      isExistRoute:true,
    };
  },
  watch: {
    $route() {
      this.pathname = this.$route.fullPath;
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */
  min-width: 1200px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue